/* HYPPE engraved can: keep the $5 "Back Text Engraving" and "Custom Design Engraving" lines tied to their can.
   Any cart change (drawer or /cart page) re-checks the cart; an engraving line whose
   _engrave_id has no can line is removed, and its quantity always follows its can.
   Uses the theme's own cart-items updateQuantity(line, qty) so the theme re-renders. */
(function () {
  if (window.__ccEngraveGuard) return; window.__ccEngraveGuard = true;
  var ADDON = { 'HYP-CAN-ENG-BACKTEXT': 1, 'HYP-CAN-ENG-DESIGN': 1 }, busy = false; /* back text + design add-ons */
  function itemsEl() {
    var d = document.querySelector('cart-drawer');
    var drawerOpen = d && (d.classList.contains('active') || d.hasAttribute('open'));
    var main = document.querySelector('cart-items:not(cart-drawer-items)');
    if (main && typeof main.updateQuantity === 'function') return main;
    var di = document.querySelector('cart-drawer-items');
    if (drawerOpen && di && typeof di.updateQuantity === 'function') return di;
    return null;
  }
  function check() {
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var canQty = {};
      cart.items.forEach(function (i) { var e = i.properties && i.properties._engrave_id; if (e && !ADDON[i.sku]) canQty[e] = (canQty[e] || 0) + i.quantity; });
      var fix = null;
      cart.items.forEach(function (i, idx) {
        if (fix || !ADDON[i.sku]) return;
        var want = canQty[(i.properties && i.properties._engrave_id) || ''] || 0;
        if (i.quantity !== want) fix = { line: idx + 1, key: i.key, quantity: want };
      });
      if (!fix) { busy = false; return; }
      var el = itemsEl();
      if (el) { busy = false; el.updateQuantity(fix.line, fix.quantity); return; } // theme publishes cartUpdate → we re-check
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: fix.key, quantity: fix.quantity, sections: ['cart-icon-bubble'], sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        busy = false;
        var b = document.getElementById('cart-icon-bubble');
        if (b && res.sections && res.sections['cart-icon-bubble']) {
          var t = document.createElement('div'); t.innerHTML = res.sections['cart-icon-bubble'];
          var n = t.querySelector('.shopify-section'); b.innerHTML = (n || t).innerHTML;
        }
        setTimeout(check, 50);
      });
    }).catch(function () { busy = false; });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(check, 200); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
